
import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {getObjectValueByPath} from '../utils/universalUtils';

@Component({name: 'CollapseMultiSelect'})
export default class CollapseMultiSelect extends Vue {
  @Prop()
  value!: any[];

  @Prop()
  itemText!: string;

  @Prop()
  translate!: boolean;

  @Emit('change')
  onChange(value: any) {
    return value;
  }

  @Emit('input')
  onInput(value: any) {
    return value;
  }

  translateText(obj: object) {
    const value = this.getValue(this.itemText, obj);

    return this.translate ? this.$t(`SYSTEM_${value}`) : value;
  }

  getValue(path: string, obj: object) {
    return getObjectValueByPath(path, obj);
  }
}
